import React from 'react';
import Select from 'react-select';

interface SelectOption {
    value: string;
    label: string;
}

interface MultiSelectProps {
    options: string[];
    onInputChange: (values: string[]) => void;
    defaultValue: string[]; // Added defaultValue prop
}

const MultiSelect: React.FC<MultiSelectProps> = ({ options, onInputChange, defaultValue }) => {
  const selectOptions: SelectOption[] = options.map(option => ({
    value: option,
    label: option
  }));

  const defaultValues = defaultValue.map(value => ({label: value, value})); // Prepare default values

  const handleChange = (selected: SelectOption[]) => {
    const values = selected.map(item => item.value);
    onInputChange(values);
  };

  return (
    <Select
      isMulti
      // closeMenuOnSelect={false}
      options={selectOptions}
      isSearchable={false}
      defaultValue={defaultValues}  // Set default values
      menuPosition={"fixed"}
      onChange={handleChange}
    />
  );
};

export default MultiSelect;